var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card",
    {
      staticClass: "jc-space licence-item",
      attrs: {
        background: _vm.disable ? "lightgrey" : null,
        "border-color": "gray-40"
      }
    },
    [
      _c("h5", { staticClass: "mt-0 mb-2 lh-big bold" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "licence-item-action mb-3 wp-10" },
        [
          !_vm.disable
            ? _c("progress-counter", {
                staticClass: "wp-10",
                attrs: { value: _vm.value, total: _vm.total }
              })
            : [
                _vm.enableSupport
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "semibold fs-3 btn-small primary-50-bkg b-1-primary-100-hover br hover-primary-100-bkg white",
                        attrs: {
                          href: "javascript:;",
                          onclick: "MySupport.getForm();"
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$l10n.__("Contacter un commercial")) +
                            "\n            "
                        )
                      ]
                    )
                  : _c("p", { staticClass: "gray-80 lh-20 fs-3 m-0" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Vous n'avez aucune licence de ce type dans votre offre."
                            )
                          ) +
                          "\n            "
                      )
                    ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "licence-item-link flex-column jc-space" },
        [
          _c(
            "p",
            { staticClass: "gray-60 mt-0 mb-2 leading-5" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c("CompassLink", {
            attrs: {
              label: _vm.$t.__(
                "sellsyaccountmanager.LicenceItem.view_modules_list"
              ),
              type: "secondary",
              size: "small",
              suffixIcon: "external-link",
              link: _vm.linkUrl,
              target: "_blank"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }